import React from 'react';
import type { FC } from 'react';
import type { Opportunity, OpportunityCandidate } from '@axiom/validation';
import { CondensedMedium, Layout } from '@axiom/ui';
import { CurrencyUtil } from '@axiom/utils';

import { CandidateRateUtil } from '../../utils/candidate-rate-util';
import { OpportunityTalentRateIndicator } from '../OpportunityTalentRateIndicator/OpportunityTalentRateIndicator';

interface OpportunityTalentRateMarginProps {
  opportunityCandidate?: OpportunityCandidate;
  opportunity: Opportunity;
}

export const OpportunityTalentRateMargin: FC<
  OpportunityTalentRateMarginProps
> = ({ opportunityCandidate, opportunity }) => {
  const hasSubmittedRate =
    CandidateRateUtil.hasSubmittedRate(opportunityCandidate);

  const getRateAndMargin = (
    rate?: OpportunityCandidate['proposedHourlyRate'],
    margin?: OpportunityCandidate['proposedMarginTarget']
  ) => {
    let rateAndMargin = 'Not Set';

    if (hasSubmittedRate) {
      rateAndMargin =
        CurrencyUtil.getFormattedCurrency({
          value: rate,
          currencyCode: opportunity.currency,
        }) || '';

      if (margin) {
        rateAndMargin += ` (${margin}%)`;
      }
    }

    return (
      <CondensedMedium name="RATE_MARGIN">{rateAndMargin}</CondensedMedium>
    );
  };

  return (
    <Layout
      direction="horizontal"
      position="left middle"
      horizontalGutter="4px"
      name="rate-and-margin"
    >
      <OpportunityTalentRateIndicator
        opportunityCandidate={opportunityCandidate}
      />
      {getRateAndMargin(
        opportunityCandidate?.proposedHourlyRate,
        opportunityCandidate?.proposedMarginTarget
      )}
    </Layout>
  );
};
